import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';

import MaterialTable from 'material-table'
import CircularProgress from '@material-ui/core/CircularProgress';
import Edit from '@material-ui/icons/Edit';
import Delete from '@material-ui/icons/Delete';

import { getDocumentsTypes, deleteDocumentType } from '../../store/actions';
import { AppState } from '../../../../store';

import * as Table from '../../../../config/tableConfig';

import { Container } from '../../../../styles/styles';

import { DocumentTypesToGet } from '../../models/interfaces';

const DocumentTypeList: React.FC = () => {
  const history = useHistory();

  const listDocumentTypes: DocumentTypesToGet[] = useSelector((state: AppState) => state.DocumentType.listDocumentTypes);
  const isLoading = useSelector((state: AppState) => state.DocumentType.isLoading);

  useEffect(() => {
    getDocumentsTypes();
  }, []);

  const deleteConfirmation = ({ id }: any) => {

    Swal.fire({
      title: 'Confirmação',
      html: "Você tem certeza que deseja remover esse tipo de documento?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Cancelar'
    }).then((res: any) => {
      if (res.value) {
        Swal.fire({
          title: 'Aguarde...',
          text: 'Removendo Tipo de Documento',
          allowEscapeKey: false,
          allowOutsideClick: false,
          showConfirmButton: false,
          didOpen: async () => {
            Swal.showLoading();

            const response = await deleteDocumentType(id);

            if (response) {
              Swal.fire(
                'Removido',
                'O Tipo de Documento foi removido com sucesso !',
                'success'
              )
            } else {
              Swal.fire({
                title: 'Erro',
                text: `Ocorreu algum erro ao executar a ação!`,
                icon: 'error',
                showConfirmButton: false,
                timer: 2000
              });
            }
          }
        });
      }
    })
  }

  return (
    <React.Fragment>
      <Container background="#E2E4E6">
        {isLoading &&
          <div style={{ textAlign: 'center' }}>
            <CircularProgress size={25} />
          </div>
        }
        {!isLoading &&
          <MaterialTable
            title=""
            localization={Table.Localization}
            options={Table.Options}
            icons={Table.Icons}
            columns={[
              {
                title: 'Nome',
                field: 'name',
                defaultSort: "desc"
              },
              {
                title: 'Quantidade de Campos',
                field: 'qtdInputs',
                cellStyle: {
                  textAlign: 'center'
                },
                headerStyle: {
                  textAlign: 'center'
                }
              },
              {
                title: 'Aviso do Vencimento',
                field: 'daysToDueNotice',
                cellStyle: {
                  textAlign: 'center'
                },
                headerStyle: {
                  textAlign: 'center'
                }
              }
            ]}
            actions={[
              {
                icon: () => <Edit />,
                tooltip: 'Editar',
                onClick: (event, rowData: any) => history.push(`edit/${rowData.id}`)
              },
              {
                icon: () => <Delete />,
                tooltip: 'Remover',
                onClick: (event, rowData: any) => deleteConfirmation(rowData)
              }
            ]}
            data={listDocumentTypes?.map(function (element) {
              var obj = {
                id: element.id,
                daysToDueNotice: element.daysToDueNotice + " Dia(s) antes",
                name: element.name,
                qtdInputs: element.documentTypeFields.length
              }
              return obj;
            })}
          />
        }

      </Container>
    </React.Fragment>
  )
}

export default DocumentTypeList;
